const UNKNOWN = `${process.env.BASE_URL}file-icon/unknown.png` // unknown

const IMAGE = `${process.env.BASE_URL}file-icon/image.png` // image
const AUDIO = `${process.env.BASE_URL}file-icon/audio.png` // audio
const VIDEO = `${process.env.BASE_URL}file-icon/video.png` // video
const DOC = `${process.env.BASE_URL}file-icon/doc.png` // doc
const PDF = `${process.env.BASE_URL}file-icon/pdf.png` // pdf
const PPT = `${process.env.BASE_URL}file-icon/ppt.png` // ppt
const XLS = `${process.env.BASE_URL}file-icon/xls.png` // xls
const ZIP = `${process.env.BASE_URL}file-icon/zip.png` // zip
const TXT = `${process.env.BASE_URL}file-icon/txt.png` // txt

const imgList: string[] = ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff']
const audioList = ['pcm', 'wav', 'mp3', 'wma', 'asf', 'ra', 'midi']
const videoList = ['avi', 'mov', 'rmvb', 'rm', 'flv', 'mp4', '3gp']
const docList = ['doc', 'docx']
const pdfList = ['pdf']
const txtList = ['txt']
const pptList = ['ppt', 'pptx']
const xlsList = ['xls', 'xlsx']
const zipList = ['rar', 'zip', 'arj', 'z']

const ext: Map<any, string> = new Map()

function setExt(list: string[], image: string) {
  list.forEach(key => {
    ext.set(key, image)
  })
}

setExt(imgList, IMAGE)
setExt(audioList, AUDIO)
setExt(videoList, VIDEO)
setExt(docList, DOC)
setExt(pdfList, PDF)
setExt(txtList, TXT)
setExt(pptList, PPT)
setExt(xlsList, XLS)
setExt(zipList, ZIP)

function getExtImg(fileName = '') {
  const index = fileName.lastIndexOf('.')
  const extName = fileName.substr(index + 1).toLowerCase()
  return ext.get(extName) || UNKNOWN
}

export default getExtImg
